import { Locale, type LocalizedString } from "../Locale.js";

export const serviceSupportAnchorMap = {
	integration: {
		[Locale.cs]: "integrace",
		[Locale.en]: "integration",
	},
	consultation: {
		[Locale.cs]: "konzultace",
		[Locale.en]: "consultation",
	},
	service: {
		[Locale.cs]: "servis",
		[Locale.en]: "service",
	},
	hotline: {
		[Locale.cs]: "hotline",
		[Locale.en]: "hotline",
	},
	financing: {
		[Locale.cs]: "financovani",
		[Locale.en]: "financing",
	},
	helpDesk: {
		[Locale.cs]: "helpdesk",
		[Locale.en]: "helpdesk",
	},
} satisfies Record<string, LocalizedString>;
